<template>
  <div>
    <vs-popup title="Confirmar" :active.sync="modal_confirm">
      <div
        style="font-size: 2.2vh; text-align: center"
        class="mb-8 text-warning"
      >
        Está seguro de guardar los registros seleccionados:
        <b> {{ cobranza_selecteds.rows.length }}</b>
      </div>

      <div
        class="grid grid-cols-1 lg:grid-cols-2 gap-10 justify-center items-center mb-12"
      >
        <div>
          <span>Seleccione una empresa</span>
          <v-select
            class="w-full style-chooser"
            v-model="company_selected"
            label="com_name"
            :options="companies"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            @input="search_users()"
          />
        </div>
        <div>
          <span>Seleccione un gestor</span>
          <v-select
            class="w-full style-chooser"
            v-model="user_selected"
            label="names"
            :options="users"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="col-span-2 flex flex-col gap-2">
          <span>Nota</span>
          <textarea
            style="background: #f2f2f2; color: #9d9d9d"
            v-model="gnc_note"
            placeholder="Agregar Nota"
            class="w-full rounded-xl p-5 border-none shadow-lg"
          ></textarea>
        </div>
      </div>

      <div class="mb-12 flex justify-center">
        <vs-checkbox v-model="confirm_mail">
          <b>¿Enviar correo al cliente?</b>
        </vs-checkbox>
      </div>

      <vs-button @click="save_cobranzas_selected" class="w-full mb-2"
        >Guardar</vs-button
      >
    </vs-popup>

    <vs-popup title="Detalle" :active.sync="modal_detail">
      <div
        class="grid grid-cols-1 lg:grid-cols-4 gap-2 py-2 justify-center items-center"
        style="
          font-size: 1.8vh !important;
          border-bottom: 1px solid rgb(227, 227, 227);
        "
        v-for="([key, value], index) in cobranza_data_modal"
        :key="index"
      >
        <div class="lg:col-span-2">
          <b>{{ key }}: </b>
        </div>
        <div class="lg:col-span-2">
          {{ typeof value === "string" ? value.replace(/\|/g, ",") : value }}
        </div>
      </div>
    </vs-popup>

    <vs-popup
      :title="'Notas cliente: ' + client_selected.currentOwnerName"
      :active.sync="notes_modal"
    >
      <div class="leading-1">
        {{ client_selected.gcc_note }} - 
        <span class="text-sm font-bold">
          Asignado por {{ client_selected.gcc_admin_name }}
        </span>
      </div>

      <div class="my-6" v-for="(item, index) in notes" :key="index">
        <div class="shadow px-4 py-2 rounded bg-[#c8dbf4]">
          <div class="mb-2">{{ item.gnc_note }}</div>
          <div class="flex justify-between text-sm">
            <span>{{ item.gestor_name }}</span>
            <span>{{ item.gnc_created_at.date.substring(0, 16) }}</span>
          </div>
        </div>
      </div>

      <div class="gap-4">
        <vs-divider></vs-divider>
        <vs-textarea v-model="note_client"></vs-textarea>
        <vs-button @click="save_note">Enviar nota</vs-button>
      </div>
    </vs-popup>

    <vs-popup :title="'Cobradores: '" :active.sync="collectors_modal">
      <div v-if="collectors.length > 0">
        <div class="mb-6" v-for="(item, index) in collectors" :key="index">
          <div class="shadow px-4 py-2 rounded bg-[#c8dbf4]">
            <p class="font-bold">Cobrador</p>
            {{ item.collector_name }} - {{ item.company_name }}
            <span class="text-sm font-bold">
              Asignado por {{ client_selected.gcc_admin_name }}
            </span>
            <p class="font-bold">Comentario</p>
            {{ item.gcc_note }}

            <div class="text-right text-sm">
              <p class="font-bold">Fecha de creación</p>
              {{ item.gcc_created_at.substring(0, 16) }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        Cliente sin cobradores asignados hasta el momento
      </div>
    </vs-popup>

    <div
      style="
        display: flex;
        gap: 20px;
        justify-content: end;
        align-items: center;
      "
    >
      <vs-button class="p-2" color="success" @click="exportToXLSX"
        >Exportar XLSX</vs-button
      >
      <vs-button class="p-2" color="danger" @click="exportToPDF"
        >Exportar PDF&nbsp;</vs-button
      >
    </div>

    <vs-table
      v-if="data_cobranza.length > 0"
      stripe
      pagination
      :max-items="items_table"
      search
      :data="data_cobranza"
    >
      <template slot="header">
        <select class="select_pagination" sty v-model="items_table">
          <option selected value="5">5</option>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </template>
      <template slot="thead">
        <vs-th>Ver</vs-th>
        <vs-th> Notas </vs-th>
        <vs-th> Estado</vs-th>
        <vs-th sort-key="segmentation"> Segmentación</vs-th>
        <vs-th> Historial cobradores </vs-th>
        <vs-th sort-key="collector_name">Cobrador asignado</vs-th>
        <vs-th sort-key="valorTotal_float">Saldo Actual</vs-th>
        <vs-th sort-key="plate">Placa</vs-th>
        <vs-th sort-key="panapass">Panapass</vs-th>
        <vs-th sort-key="accountType">Tipo Cuenta</vs-th>
        <vs-th sort-key="currentOwnerName">Nombre Cliente</vs-th>
        <vs-th sort-key="currentOwnerDocumentNumber">Número Identificación</vs-th>
        <vs-th>Envío email</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :key="indextr"
          v-for="(tr, indextr) in data"
          style="cursor: pointer; text-align: center"
        >
          <vs-td
            ><vs-button
              @click="open_modal(tr)"
              size="small"
              radius
              color="dark"
              type="border"
              icon-pack="feather"
              icon="icon-search"
            ></vs-button
          ></vs-td>
          <vs-td
            ><vs-button
              @click="
                note_client='';
                client_selected = tr;
                getNotes();
              "
              size="small"
              radius
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-file"
            ></vs-button
          ></vs-td>
          <vs-td>
            <div v-if="tr.collector_name">
              <vs-button v-if="tr.status_cobranza==1" @click="save_status_cobranza(tr, 0)" size="small" color="success" type="line" class="px-1">Cobrado</vs-button >
              <vs-button v-if="tr.status_cobranza==0" @click="save_status_cobranza(tr, 1)" size="small" color="warning" type="line" class="px-1">Pendiente</vs-button >
              <vs-button v-if="tr.status_cobranza==2" size="small" color="danger" type="line" class="px-1">Gestionado por otro cobrador</vs-button >
            </div>
          </vs-td>
          <vs-td>
            {{ tr.segmentation }}
          </vs-td>
          <vs-td
            ><vs-button
              @click="
                client_selected = tr;
                search_collectors();
              "
              size="small"
              radius
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-users"
            ></vs-button
          ></vs-td>
          <td class="text-sm">{{ tr.collector_name }} <div class="text-xxs">{{tr.gcc_created_at_formated}}</div> </td>
          <!-- <td>{{ tr.gestor }}</td> -->
          <td>{{ Math.abs(tr.valorTotal_float) }}</td>
          <td>{{ tr.plate }}</td>
          <td>{{ tr.panapass }}</td>
          <td>{{ tr.accountType }}</td>
          <td>{{ tr.currentOwnerName }}</td>
          <td>{{ tr.currentOwnerDocumentNumber }}</td>
          <td>{{ tr.gcc_status_email==1 ? 'enviado' : 'No enviado' }}</td>
          <!-- <td>{{ tr.tag }}</td> -->
          <!-- <td>
            <span v-if="tr.gcc_created_at != null">{{
              tr.gcc_created_at.date.substring(0, 19)
            }}</span>
          </td> -->
          <!-- <td><span v-if="tr.gcc_created_at != null">{{ tr.gcc_created_at }}</span></td> -->
          <!-- <vs-td>
            <vs-checkbox
              v-model="cobranza_selecteds.rows"
              :vs-value="tr"
            ></vs-checkbox>
          </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import axios from "@/axios";
import Swal from "sweetalert2";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import traducciones_json from "../../../views/traducciones.json";
export default {
  components: {},
  props: {
    data_cobranza: {
      type: Array,
      default: [],
    },
    companies: {
      type: Array,
      default: [],
    },
    min_range: {
      type: [Number, String],
      default: 0,
    },
    max_range: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      config: null,
      cobranza_selecteds: { rows: [] },
      cobranza_data_modal: [],
      modal_detail: false,
      modal_confirm: false,
      traducciones: traducciones_json,
      users: [],
      company_selected: [],
      user_selected: [],
      items_table: 5,
      confirm_mail: false,
      gnc_note: "",
      notes_modal: false,
      collectors_modal: false,
      notes: [],
      client_selected: {},
      note_client: "",
      user_session: {},
      collectors: [],
    };
  },
  mounted() {
    this.config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.accessToken,
      },
    };

    this.user_session = localStorage.user_session
      ? JSON.parse(localStorage.user_session)
      : {};
  },

  methods: {
    search_users() {
      this.$vs.loading();
      let me = this;
      axios
        .get(
          `auth/getUsersCompany/${this.company_selected.com_id}`,
          this.config
        )
        .then(function (response) {
          me.users = response.data;

          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    setDataCheck(item) {
      this.cobranza_selecteds.rows = this.cobranza_selecteds.rows.filter(
        (value) => value.Cuenta !== item.Cuenta
      );
      this.cobranza_selecteds.rows.push(item);
    },
    checkAll() {
      if (this.cobranza_selecteds.rows == this.data_cobranza) {
        this.cobranza_selecteds.rows = [];
      } else {
        this.cobranza_selecteds.rows = this.data_cobranza;
      }
    },
    open_modal(item_sel) {
      const traduccionesMap = this.traducciones.reduce((map, traduccion) => {
        map[traduccion.en] = traduccion.es;
        return map;
      }, {});

      if (typeof item_sel === "object" && item_sel !== null) {
        // Convertir el objeto en un array de entradas
        this.detal_selected = Object.entries(item_sel).reduce(
          (nuevoObjeto, [clave, valor]) => {
            const traduccion = traduccionesMap[clave];
            if (traduccion) {
              nuevoObjeto[traduccion] = valor;
            } else {
              nuevoObjeto[clave] = valor;
            }
            return nuevoObjeto;
          },
          {}
        );

        // Convertir el nuevo objeto en un array de entradas para el template
        this.cobranza_data_modal = Object.entries(this.detal_selected);
      } else {
        console.error("item_sel no es un objeto o es null:", item_sel);
        this.detal_selected = {};
        this.cobranza_data_modal = [];
      }

      this.modal_detail = true;
    },
    async save_cobranzas_selected() {
      let me = this;

      if (this.cobranza_selecteds.rows.length == 0) {
        this.$vs.notify({
          title: "Alerta",
          text: "Seleccione almenos un registro",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-triangle",
          position: "top-center",
        });
        return;
      }
      if (this.user_selected.length == 0) {
        this.$vs.notify({
          title: "Alerta",
          text: "Seleccione un gestor",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-triangle",
          position: "top-center",
        });
        return;
      }

      this.$vs.loading();

      let data_form = {
        cobranza_data: this.cobranza_selecteds.rows,
        user: this.user_selected.id,
        email: this.user_selected.email,
        user_name: this.user_selected.names,
        confirm_mail: this.confirm_mail ? 1 : 0,
        gcc_note: this.gnc_note,
      };

      // const date = new Date();

      await axios
        .post(`auth/save_cobranzas_selected`, data_form, this.config)
        .then(function (response) {
          if (response.data == 1) {
            data_form.confirm_mail
              ? Swal.fire({
                  title:
                    "¡Éxito! Registros seleccionados guardados exitosamente",
                  text: "Recibiras un correo de confirmación cuando se hayan enviado todos los email de contacto a los clientes seleccionados.",
                  icon: "success",
                })
              : Swal.fire({
                  title:
                    "¡Éxito! Registros seleccionados guardados exitosamente",
                  icon: "success",
                });
          } else {
            Swal.fire({
              title: "Alerta!",
              text: response.data,
              icon: "info",
            });
          }
          me.cobranza_selecteds.rows = [];
          me.$emit("search_cobranza");

          me.modal_confirm = false;
          me.$vs.loading.close();
        })
        .catch(function (error) {
          Swal.fire({
            title: "¡Error!",
            text: "Error al guardar registros seleccionados" + error,
            icon: "danger",
          });
          me.$vs.loading.close();
        });
    },
    exportToXLSX() {
      const XLSX = require("xlsx");
      const dataQuery = this.data_cobranza.map((item) => ({
        ...item,
        gcc_status_email: item.gcc_status_email == 1 ? "Enviado" : "No enviado",
      }));

      // Crear una hoja de trabajo a partir de los datos
      const worksheet = XLSX.utils.json_to_sheet(dataQuery);

      // Obtener el rango de encabezados de la hoja de trabajo
      const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);

      // Crear un objeto de traducciones para los encabezados
      const translationMap = this.traducciones.reduce((map, item) => {
        map[item.en] = item.es;
        return map;
      }, {});

      // Reemplazar los encabezados en la hoja de trabajo con las traducciones
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const columnHeader = XLSX.utils.encode_col(col) + "1";
        if (worksheet[columnHeader]) {
          // Reemplazar el encabezado con la traducción correspondiente
          const originalHeader = worksheet[columnHeader].v;
          worksheet[columnHeader].v =
            translationMap[originalHeader] || originalHeader;
        }
      }

      // Crear un libro nuevo y agregar la hoja de trabajo
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

      // Convertir el libro a un buffer y guardar el archivo
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(data, "datos.xlsx");
    },
    async exportToPDF() {
      let me = this;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.accessToken,
        },
      };
      let api_url = process.env.api.slice(0, -1).replace(/\bapi\b/g, "");
      let data = { data_query: this.data_cobranza, type: "consulta" };
      this.$vs.loading();
      await axios
        .post(`auth/generate_pdf`, data, config)
        .then((res) => {
          me.$vs.loading.close();
          window.open(api_url + res.data.path_document, "_blank");
        })
        .catch(function (error) {
          alert(error);
          me.$vs.loading.close();
        });
    },
    async getNotes() {
      // !this.notes && this.$vs.loading();
      const notes = await axios
        .get(
          `/auth/get_notes_client/${this.client_selected.plate}/${this.client_selected.currentOwnerDocumentNumber}/${this.client_selected.panapass}`
        )
        .then((response) => response.data);
      this.notes = notes;

      // this.notes && me.$vs.loading.close();
      this.notes_modal = true;
    },
    save_note() {
      if (this.note_client) {
        let me = this;
        let data = {
          gnc_note: this.note_client,
          client_plate: this.client_selected.plate,
          currentOwnerDocumentNumber: this.client_selected.currentOwnerDocumentNumber,
          client_panapass: this.client_selected.panapass,
          gestor_name: this.user_session.user_name,
          gestor_id: this.user_session.id,
        };

        if (
          (this.client_selected.plate === "0" || this.client_selected.plate === undefined) && (this.client_selected.currentOwnerDocumentNumber === "0" || this.client_selected.currentOwnerDocumentNumber === undefined) && (this.client_selected.panapass === "0" || this.client_selected.panapass === undefined)
        ) {
          this.$vs.notify({
            title: "Alerta",
            text: "No se puede agregar una nota, el cliente no tiene Número de identificación, Placa o Panapass",
            color: "warning",
            iconPack: "feather",
            icon: "icon-alert-triangle",
            position: "top-center",
          });
          this.notes_modal = false;
          return;
        }
        this.$vs.loading();

        axios
          .post("/auth/save_note_client", data, this.config)
          .then(function (response) {
            me.getNotes();
            me.note_client = "";
            me.$vs.loading.close();
          })
          .catch(function (error) {
            me.$vs.loading.close();
          });
      }
    },
    search_collectors() {
      axios
        .get(`/auth/get_collectors_client/${this.client_selected.plate}/${this.client_selected.panapass}`)
        .then((response) => {
          this.collectors = response.data;
        });
      this.collectors_modal = true;
    },
    validEmail(email, email_mupa) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if( email == 'cambiar@cambiar.com'){
        if( email_mupa == 'cambiar@cambiar.com'){
          return false;
        }else{
          return false;
        }
      }

      return emailPattern.test(email) || emailPattern.test(email_mupa);
    },
    save_status_cobranza(item, status){
      let me = this;
      let text_action = status == 1 ? 'COBRADO' : 'PENDIENTE'
      Swal.fire({
          icon: 'info',
          title: 'Está seguro de cambiar el estado de este cliente a '+ text_action +'?',
          showCancelButton: true,
          confirmButtonColor: '#21409A',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          me.$vs.loading();
          axios
          .post(
            `auth/save_status_cobranza`, 
            {
              plate: item.plate,
              panapass: item.panapass,
              status_cobranza: status,
              collector_id: item.collector_id
            },
            me.config
          )
          .then(function (response) {
            item.status_cobranza = status
            me.$vs.loading.close();
          })
          .catch(function (error) {
            me.$vs.loading.close();
          });
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped></style>
